
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 17 17"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"i-Vector 158",attrs:{"stroke":"#234652","stroke-linecap":"round","d":"M9.5 2.5v5.206a1 1 0 0 0 .159.541l1.925 2.995M9.5 2.5h-2m2 0h.5m-2.5 0v5.206a1 1 0 0 1-.159.541L5.893 10.5l-.643 1m2.25-9H7m4.584 8.742 1.233 1.662a1 1 0 0 1-.803 1.596H5a1 1 0 0 1-.8-1.6l1.05-1.4m6.334-.258C10 12 9.5 12 8 11c-.588-.392-1.5-.5-2.75.5"}})])
          )
        }
      }
    